// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-metricScorecard-module__card--mxmf3 {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: #071c35; /* @blue1 */
  color: #ffffff;
  text-align: center;
  height: 146px;
  padding: 16px;
  border-radius: 0;
  min-width: 0;
  border: 3px solid #414141; /* per Figma */
}

.src-js-pages-usageReportingContainer-components-metricScorecard-module__cardOrange--WJ9oR {
  background-color: #071c35;
  border-color: #414141;
}

.src-js-pages-usageReportingContainer-components-metricScorecard-module__label--nTeFM {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: #ffffff;
  margin: 0;
}

.src-js-pages-usageReportingContainer-components-metricScorecard-module__value--VCIKs {
  font-size: 30px !important;
  font-weight: 700;
  line-height: 1.1;
  margin: 0;
}

.src-js-pages-usageReportingContainer-components-metricScorecard-module__subtitle--xVazS {
  max-width: 100%;
  height: 20px;
  font-family: 'Proxima Nova', sans-serif;
  font-size: 12px;
  font-weight: 200;
  line-height: 20px;
  letter-spacing: normal;
  text-align: center;
  color: #FDFDFD;
  margin: 0;
}

`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/metricScorecard.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB,EAAE,WAAW;EACtC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX","sourcesContent":[".card {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background-color: #071c35; /* @blue1 */\n  color: #ffffff;\n  text-align: center;\n  height: 146px;\n  padding: 16px;\n  border-radius: 0;\n  min-width: 0;\n  border: 3px solid #414141; /* per Figma */\n}\n\n.cardOrange {\n  background-color: #071c35;\n  border-color: #414141;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: #ffffff;\n  margin: 0;\n}\n\n.value {\n  font-size: 30px !important;\n  font-weight: 700;\n  line-height: 1.1;\n  margin: 0;\n}\n\n.subtitle {\n  max-width: 100%;\n  height: 20px;\n  font-family: 'Proxima Nova', sans-serif;\n  font-size: 12px;\n  font-weight: 200;\n  line-height: 20px;\n  letter-spacing: normal;\n  text-align: center;\n  color: #FDFDFD;\n  margin: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `src-js-pages-usageReportingContainer-components-metricScorecard-module__card--mxmf3`,
	"cardOrange": `src-js-pages-usageReportingContainer-components-metricScorecard-module__cardOrange--WJ9oR`,
	"label": `src-js-pages-usageReportingContainer-components-metricScorecard-module__label--nTeFM`,
	"value": `src-js-pages-usageReportingContainer-components-metricScorecard-module__value--VCIKs`,
	"subtitle": `src-js-pages-usageReportingContainer-components-metricScorecard-module__subtitle--xVazS`
};
export default ___CSS_LOADER_EXPORT___;
